<template>
  <form action="" class="w-75 mx-auto">
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="family" class="form-label">Grupo de formas asociado:</label>
      </div>
      <div class="col-sm-7">
        <select class="form-select" id="family" v-model="family">
          <option selected>Opciones disponibles...</option>
          <option v-for="family in families" :key="family._id" v-bind:value="family.id">
            {{ family.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="imageForm" class="form-label">Nombre de la forma:</label>
      </div>
      <div class="col-sm-7">
        <input type="text" v-model="imageForm" class="form-control" id="imageForm" />
      </div>
    </div>
    <div class="row align-items-center p-3">
      <div class="col-sm-5">
        <label for="imageFile" class="form-label">Imagen de la forma:</label>
      </div>
      <div class="col-sm-7">
        <input type="file" class="form-control" id="imageFile" ref="file" @change="previewFile" />
      </div>
      <!-- {{ imageFile }} -->
    </div>
    <h4 class="mt-3"><i>Propiedades de la forma</i></h4>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="imageDistances" class="form-label">Cantidad de distancias:</label>
      </div>
      <div class="col-sm-7">
        <input type="number" min="0" v-model="imageDistances" class="form-control" id="imageDistances" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="imageAngles" class="form-label">Cantidad de ángulos:</label>
      </div>
      <div class="col-sm-7">
        <input type="number" min="0" v-model="imageAngles" class="form-control" id="imageAngles" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="imageDiameters" class="form-label">Cantidad de diámetros:</label>
      </div>
      <div class="col-sm-7">
        <input type="number" min="0" v-model="imageDiameters" class="form-control" id="imageDiameters" />
      </div>
    </div>
    <div class="row align-items-center p-3">
      <div class="col-sm-5">
        <label for="imageRadius" class="form-label">Cantidad de radios:</label>
      </div>
      <div class="col-sm-7">
        <input type="number" min="0" v-model="imageRadius" class="form-control" id="imageRadius" />
      </div>
    </div>
    <div class="card border-dark mb-3 p-2">
      <p>Tenga en cuenta que tanto en la formulación para el cálculo del desarrollo como para el cálculo de los servicios,
        debe
        referirse a cada propiedad de la forma utilizando la siguientes convenciones. </p>
      <mark><strong><i>Distancias = D / Diámetros = DT / Radios = R / Ángulos = A </i></strong></mark>
      <p class="mt-3">Así mismo, es importante que cuando se refiera a alguna operación aritmética diferente a aquellas
        presentes en su
        teclado, lo haga de la siguiente manera.</p>
      <mark><strong><i>Raiz cuadradra = RAIZ(base) / Potencia = POTENCIA(base,exponente)</i></strong></mark>
    </div>
    <h4 class="mt-3"><i>Formulación de la forma para el calculo de su desarrollo</i></h4>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="conceptionLength" class="form-label">Fórmula para el largo:</label>
      </div>
      <div class="col-sm-7">
        <input type="text" v-model="conceptionLength" class="form-control" id="conceptionLength" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="conceptionWidth" class="form-label">Fórmula para el ancho:</label>
      </div>
      <div class="col-sm-7">
        <input type="text" v-model="conceptionWidth" class="form-control" id="conceptionWidth" />
      </div>
    </div>
    <h4 class="mt-3"><i>Sevicios sobre la forma</i></h4>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-6 col-12 align-items-center p-2">
        <label for="imgServiceFold" class="form-label">Doblez <i>(Cantidad de dobleces)</i>:</label>
      </div>
      <div class="col-sm-4 col-12 mb-2">
        <input type="number" min="0" v-model="imgServiceFold" class="form-control" id="imgServiceFold" />
      </div>
    </div>
    <div class="row align-items-center p-3">
      <mark><i>Recuerde utilizar las propiedaddes de la forma (Distancias, Diámetros, Radios y Ángulos) para
          establecer las fórmulas del calculo de servicios de forma adecuada.</i></mark>
    </div>
    <div class="row aling-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>
          Corte con cizalla:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceShearCut"
          v-model="imgServiceShearCut" />
        <label class="form-check-label" for="imgServiceShearCut">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6><strong>Fórmula para el cálculo del servicio de corte con cizalla:</strong></h6>
        <input class="form-check-input" type="checkbox" role="switch" id="laserCutService"
          v-model="shearCutConceptionAvailable" @change="useShearCutConception" />
        <label class="form-check-label ms-1" for="laserCutService"><i>No utilizar fórmula</i></label>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-control ms-5" type="text" id="imgSeviceShearCutConception"
          v-model="imgServiceShearCutConception" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Corte CNC <i>(Plasma)</i>:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSevicePlasmaCutting"
          v-model="imgServicePlasmaCutting" />
        <label class="form-check-label" for="imgServicePlasmaCutting">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Corte láser:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceLaserCutting"
          v-model="imgServiceLaserCutting" />
        <label class="form-check-label" for="imgServiceLaserCutting">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2 mt-4">
        <h6>Oxicorte:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceFlamingCut"
          v-model="imgServiceFlamingCut" />
        <label class="form-check-label" for="imgServiceFlamingCut">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6> <strong> Fórmula para el cálculo de los servicios de plasma, lasér y oxicorte: </strong></h6>
        <input class="form-check-input" type="checkbox" role="switch" id="laserCutService"
          v-model="otherCutServicesConceptionAvailable" @change="useOtherCutServicesConception" />
        <label class="form-check-label ms-1" for="laserCutService"><i>No utilizar fórmula</i></label>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-control ms-5" type="text" id="imgOtherCuttingSevicesConception"
          v-model="imgOtherCuttingServicesConception" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Rolado recto:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceRolled"
          v-model="imgServiceRolled" />
        <label class="form-check-label" for="imgServiceRolled">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Rolado cónico:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceRolledC"
          v-model="imgServiceRolledC" />
        <label class="form-check-label" for="imgServiceRolledC">Aplica</label>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Soldadura de electrodo:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceWeldingElect"
          v-model="imgServiceWeldingElect" />
        <label class="form-check-label" for="imgServiceWeldingElect">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Soldadura <i>MIG</i>:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceWeldingMig"
          v-model="imgServiceWeldingMig" />
        <label class="form-check-label" for="imgServiceWeldingMig">Aplica</label>
      </div>
    </div>
    <div class="row align-items-center border-bottom p-3 ">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Abombado:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceConvex" v-model="imgServiceConvex"
          disabled />
        <label class="form-check-label" for="imgServiceConvex">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Pestañado:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceEyelashed"
          v-model="imgServiceEyelashed" disabled />
        <label class="form-check-label" for="imgServiceEyelashed">Aplica</label>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <label for="imgServicePunching1" class="form-label">Punzonado menor a <i>40mm</i>:</label>
      </div>
      <div class="col-sm-3 col-12 p-2">
        <input type="number" min="0" v-model="imgServicePunching1" class="form-control" id="imgServicePunching1" />
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <label for="imgServicePunching2" class="form-label">Punzonado mayor a <i>40mm</i>:</label>
      </div>
      <div class="col-sm-3 col-12 mb-1">
        <input type="number" min="0" v-model="imgServicePunching2" class="form-control" id="imgServicePunching2" />
      </div>
    </div>
    <div class="mt-3 mb-3">
      <button class="btn btn-danger" @click.prevent="saveImageSheet()">
        Guardar forma
      </button>
    </div>
  </form>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      familyDefault: "Laminas",
      families: [],
      family: "",
      imageForm: "",
      imageDistances: 0,
      imageAngles: 0,
      imageRadius: 0,
      imageDiameters: 0,
      imgServiceFold: 0,
      imgServiceShearCut: false,
      imgServiceFlamingCut: false,
      imgServicePlasmaCutting: false,
      imgServiceLaserCutting: false,
      imgServiceWeldingElect: false,
      imgServiceWeldingMig: false,
      imgServiceRolled: false,
      imgServiceRolledC: false,
      imgServicePunching1: 0,
      imgServicePunching2: 0,
      imgServiceConvex: false,
      imgServiceEyelashed: false,
      imageFile: undefined,
      currentFile: undefined,
      conceptionLength: "",
      conceptionWidth: "",
      imageOrder: 0,
      imgServiceShearCutConception: "",
      imgOtherCuttingServicesConception: "",
      shearCutConceptionAvailable: false,
      otherCutServicesConceptionAvailable: false,
    };
  },
  methods: {
    previewFile(event) {
      // this.imageFile = event.target.files;
      // this.imageFile2 = event.target.files[0];
      // console.log(this.imageFile);
      // console.log(this.imageFile2);
      this.imageFile = this.$refs.file.files;
      // console.log(this.imageFile);
      this.currentFile = this.imageFile.item(0);
      // console.log(this.currentFile);
    },
    useShearCutConception() {
      this.shearCutConceptionAvailable ? this.imgServiceShearCutConception = "no_aplica" : this.imgServiceShearCutConception = "";
    },
    useOtherCutServicesConception() {
      this.otherCutServicesConceptionAvailable ? this.imgOtherCuttingServicesConception = "no_aplica" : this.imgOtherCuttingServicesConception = "";
    },
    async saveImageSheet() {
      if (this.family === 0 || this.imageForm === "" || this.currentFile == null || this.currentFile.name == "" || this.conceptionLength == "" || this.conceptionWidth == "" || this.imgOtherCuttingServicesConception == "") {
        alert("Campos vacios, por favor, complete aquellos que son obligatorios pimero.")
      } else {
        let formData = new FormData();
        formData.append("img_form_family_id", this.family);
        formData.append("imageForm", this.imageForm);
        formData.append("imageFile", this.currentFile);
        formData.append("imageName", this.currentFile.name);
        formData.append("imageDistances", this.imageDistances);
        formData.append("imageAngles", this.imageAngles);
        formData.append("imageDiameters", this.imageDiameters);
        formData.append("imageRadius", this.imageRadius);
        formData.append("imgServiceFold", this.imgServiceFold);
        formData.append(
          "imgServiceShearCut",
          this.imgServiceShearCut ? "aplica" : "no_aplica"
        );
        formData.append(
          "imgServiceFlameCutting",
          this.imgServiceFlamingCut ? "aplica" : "no_aplica"
        );
        formData.append(
          "imgServicePlasmaCutting",
          this.imgServicePlasmaCutting ? "aplica" : "no_aplica"
        );
        formData.append(
          "imgServiceLaserCutting",
          this.imgServiceLaserCutting ? "aplica" : "no_aplica"
        );
        formData.append(
          "imgServiceWeldingElectrode",
          this.imgServiceWeldingElect ? "aplica" : "no_aplica"
        );
        formData.append(
          "imgServiceWeldingMig",
          this.imgServiceWeldingMig ? "aplica" : "no_aplica"
        );
        formData.append(
          "imgServiceRolled",
          this.imgServiceRolled ? "aplica" : "no_aplica"
        );
        formData.append(
          "imgServiceRolledC",
          this.imgServiceRolledC ? "aplica" : "no_aplica"
        );
        formData.append("imgServicePunching1", this.imgServicePunching1);
        formData.append("imgServicePunching2", this.imgServicePunching2);
        formData.append("imgServiceConvex", "no_aplica");
        formData.append("imgServiceEyelashed", "no_aplica");
        // Conception of cutting services
        formData.append("imgServiceShearCutConception", this.imgServiceShearCutConception);
        formData.append("imgOtherServicesConception", this.imgOtherCuttingServicesConception);
        //Development
        formData.append("imageConceptionLength", this.conceptionLength);
        formData.append("imageConceptionWidth", this.conceptionWidth);
        // formData.append("imageOrder", this.imageOrder);

        // formData.forEach(element => {
        //   console.log(element)
        // });
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/sheet/image/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            alert("Forma: " + this.imageForm + ", guardada con exito!");
            this.cleanFields();
            this.$router.push("/Admin/SheetImages");
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    cleanFields() {
      this.family = "";
      this.imageForm = "";
      this.imageFile = null; // o this.imageFile = undefined;
      this.currentFile = null; // Restablece también la variable si es necesario
      this.imageDistances = 0;
      this.imageAngles = 0;
      this.imageDiameters = 0;
      this.imageRadius = 0;
      this.conceptionLength = "";
      this.conceptionWidth = "";
      this.imgServiceFold = "";
      this.imgServiceShearCut = false;
      this.imgServiceFlamingCut = false;
      this.imgServicePlasmaCutting = false;
      this.imgServiceLaserCutting = false;
      this.imgServiceWeldingElect = false;
      this.imgServiceWeldingMig = false;
      this.imgServiceRolled = false;
      this.imgServiceRolledC = false;
      this.imgServicePunching1 = "";
      this.imgServicePunching2 = "";
      this.imgOtherCuttingServicesConception = "";
      this.imgServiceShearCutConception = "";
    },
  },
  beforeMount() {
    axios
      .get(RUTA_SERVIDOR + "api/imgFormFamily/list", {
        params: {
          imgFormFamily_type: this.familyDefault,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.families = res.data))
      .catch((err) => console.log(`There has been an error ${err}`));
  },
};
</script>